import { ResponseDto } from '@diritto/common/base/response.dto';
import { FavoriteContentResponseDto } from '@diritto/common/userReaction/dtos/favorite-content.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class FavoriteContentApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getFavorite(contentId: number) {
    const res = await this.http.get<FavoriteContentResponseDto>(`${this.url}/contents/${contentId}/favorite`);
    return res.data;
  }

  async setFavoriteContent(contentId: number): Promise<ResponseDto> {
    const res = await this.http.post<undefined, ResponseDto>(`${this.url}/contents/${contentId}/favorite`);
    return res.data;
  }

  async releaseFavoriteContent(contentId: number): Promise<ResponseDto> {
    const res = await this.http.delete<ResponseDto>(`${this.url}/contents/${contentId}/favorite`);
    return res.data;
  }

  async releaseFavoriteContents(contentIds: number[]): Promise<ResponseDto> {
    const res = await this.http.delete<ResponseDto>(`${this.url}/contents/favorite/bulk`, {
      data: { contentIds },
    });
    return res.data;
  }
}
